<template>
  <div class="mx-10">
    {{ value }}
    <vue-slider v-model="value" :min="60" :max="99"></vue-slider>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'

export default {
    components: {
      VueSlider
    },
    data: function () {
      return {
        value: 60,
      }
    }
  };
</script>